import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.Content.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DialogContent = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
    className: clsx("pd:dialog__content", className)
  }, rest), {
    children
  }));
};
var Dialog_Content_default = DialogContent;
export { Dialog_Content_default };